module.exports = __webpack_public_path__ + "images/bailli-e053ecdfacf8d85588dde9ebc27c3e66.jpg";